import "./Packages.module.css";
import Header from "@/reusable_sections/Header";
import ChooseYourPackage from "./sections/ChooseYourPackage";
import Services from "./sections/Services";
import ResourcesCTA from "./sections/ResourcesCTA";
import MarketplaceFooter from "@/reusable_sections/Footer";
export default function PackagesPage() {
  return <div>
      <Header />
      <ChooseYourPackage />
      <Services />
      <ResourcesCTA />
      <MarketplaceFooter />
    </div>;
}